import { Component, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ApecoToastrService } from '../../shared/services/apeco-toastr.service';

@Component({
  selector: 'app-user-type',
  templateUrl: './user-type.component.html',
  styleUrl: './user-type.component.scss',
  imports: [FormsModule, TranslateModule],
  standalone: true
})
export class UserTypeComponent {
  userPreferences = 'Parent';
  private authService = inject(AuthService);
  private toaster = inject(ApecoToastrService);
  private router = inject(Router);

  submit() {
    this.authService.setPreference({ value: this.userPreferences }).subscribe({
      next: () => {
        this.router.navigateByUrl('/workspace');
      },
      error: (err) => {
        this.toaster.error(err?.error?.Message);
      }
    });
  }
}
